import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const EApplicationBasicInfoComponent = ({ selectEApplications, handleInnerFormChange}: any) => {

    return (
        <>
  <AccordionContainer
                  child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                          label="ThirdPartyDigitalCheckInApiURL"
                          name="ThirdPartyDigitalCheckInApiURL"
                          onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'DigitalCheckInConfigurations.ThirdPartyDigitalCheckInApiURL',
                              selectEApplications?.DigitalCheckInConfigurations,
                            );
                          }}
                          type="text"
                          value={selectEApplications?.DigitalCheckInConfigurations?.ThirdPartyDigitalCheckInApiURL}
                        />
                      </div>
                  }
                  expandedPanel="BasicInfo"
                  headerTitle="BasicInfo"
                />
    </>
  )
}
export default EApplicationBasicInfoComponent;
